var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    fill: "#22A39F",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.933 226.459-36.633-28.159 36.632-20.931v49.091zm365.92-28.35-35.786 26.84v-46.82zm-137.436 143.071 151.091-113.321v226.641zm-105.081 20.49-154.098 118.33h390.926l-158.413-118.821-30.29 22.72a16.007 16.007 0 0 1 -19.351-.109zm-172.846-132.861 146.587 112.68-146.587 112.561zm441.566-52.728-61.989-34.6v-125.481a16 16 0 0 0 -16-16h-298.135a16 16 0 0 0 -16 16v124.51l-62.318 35.609a37.543 37.543 0 0 0 -19.124 32.951v264.979a38 38 0 0 0 37.95 37.951h417.12a38 38 0 0 0 37.95-37.951v-264.83a37.5 37.5 0 0 0 -19.454-33.138zm-163.856 38.208v-44.83c0-.3 0-.6 0-.9-.637-35.15-28.324-62.629-63.2-62.629a63.205 63.205 0 1 0 32.419 117.45 34.05 34.05 0 0 0 60.768 10.31 113.359 113.359 0 1 0 -93.187 48.799 16 16 0 1 0 0-32 81.33 81.33 0 1 1 66.9-35.042 2.03 2.03 0 0 1 -3.693-1.159zm-32-45.091a31.212 31.212 0 0 1 -31.2 31.143 31.206 31.206 0 0 1 0-62.411c17.191 0 30.848 13.659 31.2 31.149z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5449bc2f2ee32bb04ec1308916d37955.svg";
export { ForwardRef as ReactComponent };